import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/mainPic1.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hi, I'm Hayder Atiyah.
              <br />
              <br />
              My main focus is building smart, scalable applications using{" "}
              <b className="purple">React.js</b>,{" "}
              <b className="purple">TypeScript</b>, and modern web technologies.
              <br />
              <br />
              I’m also comfortable with backend development—especially{" "}
              <b className="purple">Spring Boot</b> and the{" "}
              <b className="purple">MERN stack</b>.<br />
              <br />I have strong experience working with databases, including{" "}
              <b className="purple">SQL</b> and{" "}
              <b className="purple">MongoDB</b>.<br />
              <br />
              At Sentari AI, I help create empathy-driven features for an AI
              journaling platform, collaborating with a large, cross-functional
              team.
              <br />
              <br />
              Always learning, always building. Let’s connect and build
              something impactful!
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/hayderAtiyah"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/hayder-atiyah-07a56a324"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/hayderatiyah7/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
